import PestPillarLayout from "../PestPillarLayout";

const PROBLEMS = [
  {
    title: "Frelons asiatiques",
    desc: "La Souterraine et sa vallée sont fortement touchées par le frelon asiatique. Nids en hauteur (arbres, cheminées), intervention urgente avec perche télescopique.",
  },
  {
    title: "Rats et souris",
    desc: "Zone gare et bâti ancien de La Souterraine : dératisation raisonnée pour habitations, dépendances et commerces avec suivi documenté.",
  },
  {
    title: "Punaises de lit",
    desc: "Hôtels de La Souterraine (position TGV), gîtes ruraux alentours : traitement vapeur sèche 180 °C, discret et sans éviction.",
  },
  {
    title: "Cafards et blattes",
    desc: "Restaurants et commerces alimentaires du centre-ville : désinsectisation HACCP avec certificat pour respect des normes sanitaires.",
  },
  {
    title: "Chenilles processionnaires",
    desc: "Nombreux pins autour de La Souterraine et Bénévent-l'Abbaye. Pose d'éco-pièges à collier, échenillage sécurisé.",
  },
  {
    title: "Guêpes en toiture",
    desc: "Nids sous les tuiles, dans les cheminées, sous les gouttières : neutralisation rapide avec combinaison intégrale et perche.",
  },
];

const FAQ = [
  {
    q: "Quel délai pour intervenir à La Souterraine ?",
    a: "La Souterraine est à 40 minutes de notre siège à La Celle-Dunoise. Nous intervenons sous 24-48 h pour les demandes standards et dans la journée pour les urgences (nid de frelons actif, envahissement massif). Aucun frais de déplacement supplémentaire.",
  },
  {
    q: "Intervenez-vous à Bénévent-l'Abbaye et Dun-le-Palestel ?",
    a: "Oui, ces deux communes sont dans notre zone d'intervention prioritaire (moins de 30 min de La Celle-Dunoise). Bénévent-l'Abbaye est spécifiquement touchée par les chenilles processionnaires du pin (forêt de Beausoleil), et Dun-le-Palestel par les frelons asiatiques.",
  },
  {
    q: "Traitez-vous les hôtels près de la gare de La Souterraine ?",
    a: "Oui, nous accompagnons plusieurs hôteliers et gîteurs de La Souterraine. Contrats annuels de prévention, intervention prioritaire en cas de suspicion punaise de lit, traitement vapeur sèche discret adapté au tourisme d'affaires TGV.",
  },
  {
    q: "Combien coûte une intervention à La Souterraine ?",
    a: "Tarifs identiques au reste de la Creuse : 90-180 € pour un nid de frelons, 150-450 € pour un traitement anti-punaises, 100-200 € pour cafards en cuisine, 200-400 € pour une dératisation raisonnée. Devis gratuit après visite ou photo.",
  },
];

export default function AntiNuisiblesLaSouterraine() {
  return (
    <PestPillarLayout
      slug="anti-nuisibles-la-souterraine"
      seoTitle="Anti-nuisibles La Souterraine (23) | K'REUSE EXTÉRIEUR"
      seoDescription="Anti-nuisibles à La Souterraine : frelons, dératisation, punaises hôtels, cafards restauration. 24-48h, Certibiocide."
      breadcrumbLabel="Anti-nuisibles La Souterraine"
      heroBadge="La Souterraine · Creuse (23)"
      heroTitleHtml={`Anti-nuisibles à <span class="font-medium text-[#1B5E20]">La Souterraine</span>`}
      heroSubtitle="Frelons asiatiques, rats, punaises de lit, cafards, chenilles processionnaires : nous intervenons à La Souterraine, Bénévent-l'Abbaye, Dun-le-Palestel et communes limitrophes sous 24-48 h."
      hero_h2="Votre entreprise anti-nuisibles à La Souterraine et l'ouest Creuse"
      introParagraphs={[
        "La Souterraine, 2ème ville du département par sa gare TGV et son activité économique, concentre plusieurs enjeux anti-nuisibles : forte pression frelons asiatiques dans la vallée, rongeurs en zone gare et bâti ancien, punaises de lit importées via le tourisme d'affaires, chenilles processionnaires dans la forêt de Beausoleil (Bénévent-l'Abbaye).",
        "K'REUSE EXTÉRIEUR intervient à La Souterraine depuis notre siège de La Celle-Dunoise (40 minutes) avec un délai standard de 24-48 h et une capacité d'intervention urgence dans la journée pour les nids de frelons actifs ou les infestations massives. Nous couvrons également Bénévent-l'Abbaye, Dun-le-Palestel, Saint-Sulpice-les-Feuilles et alentours.",
        "Certifié Certibiocide, notre équipe travaille aussi bien avec les particuliers (maisons, jardins, dépendances) qu'avec les professionnels : hôteliers de La Souterraine, restaurants et commerces alimentaires du centre, syndics de copropriété, exploitants agricoles. Attestation d'intervention systématique et confidentialité contractuelle.",
      ]}
      problems={PROBLEMS}
      method={[
        { title: "Contact", desc: "Appel, WhatsApp ou formulaire en ligne. Diagnostic à distance ou visite sous 24-48 h à La Souterraine." },
        { title: "Devis clair", desc: "Devis gratuit détaillé avec méthode, produits et éventuelle éviction. Aucun surcoût de déplacement." },
        { title: "Intervention", desc: "Déplacement à La Souterraine avec le matériel adapté. Vapeur sèche pour matelas/textiles, biocides ciblés au besoin." },
        { title: "Suivi", desc: "Contrôle post-intervention selon la nature du traitement. Contrats annuels disponibles pour les hôteliers et gîteurs." },
      ]}
      cities={["Bénévent-l'Abbaye", "Dun-le-Palestel", "Saint-Sulpice-les-Feuilles", "Marsac", "Bazelat", "Saint-Vaury", "Fresselines"]}
      faq={FAQ}
      ctaTitle="Un problème de nuisibles à La Souterraine ?"
      whatsappText="Bonjour, j'ai besoin d'une intervention anti-nuisibles à La Souterraine."
    />
  );
}
